import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Button } from 'react-bootstrap';
import axios from './../../../constants/axios';
import alert from 'alertify.js';
import selectOptionFormatter from './../../../selectors/selectOptionFormatter';

import InputControl from './../../FormTemplate/InputControl';
import Select from './../../FormTemplate/Select';

class NewEditChartOfAccountForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         chartOfAccountTypes: []
      };
   }

   componentDidMount() {
      axios.get('accounting/chartOfAccounts/getChartOfAccountTypes')
         .then((res) => {
            this.setState({
               chartOfAccountTypes: selectOptionFormatter(res.data)
            });
         });
   }

   save = (values) => {
      return axios.post('accounting/chartOfAccounts', values)
         .then((res) => {
            if (res.status === 201) {
               alert.success('New Created.');
               this.context.router.push('chartOfAccount');
            } else {
               alert.error('Something Went Wrong. Call Rasel');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };


   render() {
      const { handleSubmit, submitting, pristine, invalid } = this.props;
      const { chartOfAccountTypes } = this.state;
      return (
         <div>
            <h3>New Chart Of Account</h3>
            <form onSubmit={handleSubmit(this.save)} autoComplete="off" noValidate >
               <Field name="id" component={InputControl} type="text" label="Chart Of Account Id" />
               <Field name="name" component={InputControl} type="text" label="Account Name" />
               <Field name="chart_of_account_type_id" allowEmpty={true} component={Select} options={chartOfAccountTypes}
                      label="Account Type" />
               <Button type="submit" bsStyle="success" block
                       disabled={submitting || pristine || invalid} >Save</Button>
            </form>
         </div>
      );
   }
}
NewEditChartOfAccountForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func
};

NewEditChartOfAccountForm.contextTypes = {
   router: React.PropTypes.object
};

NewEditChartOfAccountForm = reduxForm({ // eslint-disable-line
   form: 'newEditChartOfAccountForm',
})(NewEditChartOfAccountForm);

export default NewEditChartOfAccountForm;



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/ChartOfAccount/NewEditChartOfAccountForm.js
 **/